<template>
	<div
		v-if="
			(currentPackConfig && currentPackConfig.length > 0) ||
			isDisplayPlaceholders
		"
		class="d-flex flex-row nowrap body align-items-md-start mb-2 mb-md-3 mb-lg-2 text-start justify-content-md-start"
	>
		<template
			v-if="
				currentPackConfig &&
				currentPackConfig.length > 0 &&
				!isDisplayPlaceholders
			"
		>
			<div
				class="d-flex flex-wrap justify-content-between justify-content-md-start"
				:class="!isPierreVacance && 'flex-md-column'"
			>
				<div
					v-for="(optionName, option_i) in currentPackConfig"
					:key="option_i"
					class="me-2 me-md-3 text-nowrap mb-2 mb-md-1 d-flex flex-row nowrap align-items-center"
				>
					<!-- LOGO DESKTOP -->
					<div class="me-2 d-md-flex d-none align-items-center">
						<svg :height="iconSize" :width="iconSize" class="icon">
							<use :xlink:href="`#___icon___${optionName}`"></use>
						</svg>
					</div>
					<!-- LOGO MOPBILE -->
					<div class="me-2 d-flex d-md-none align-items-center">
						<svg
							:height="iconSize"
							:width="iconSize"
							class="icon text-primary-blue"
						>
							<use :xlink:href="`#___icon___${optionName}`"></use>
						</svg>
					</div>
					<span class="d-flex align-items-center gap-1">
						{{ content[`planningSummary_options_${optionName}`] }}
						<span class="caption text-grey-700 d-flex align-items-center">
							{{ `(${participantsLength_adults}` }}
							<svg
								:height="iconSize_adult"
								:width="iconSize_adult"
								class="icon"
								style="margin-bottom: 2px"
							>
								<use xlink:href="#___icon___person"></use>
							</svg>
							<template v-if="participantsLength_children > 0">
								{{ "+" }}
								{{ participantsLength_children }}
								<svg
									:height="iconSize_child"
									:width="iconSize_child"
									class="icon"
								>
									<use xlink:href="#___icon___person"></use>
								</svg>
							</template>
							<span
								class="d-none d-md-block me-1"
								v-if="isServiceToDisplayDuration(optionName) && !isCS(variant) && !variant.isNewSkiPassValid"
								>, {{ getServiceDuration(optionName) }}</span
							>
							<span
								class="d-none d-md-block me-1"
								v-if="isServiceToDisplayDuration(optionName) && !isCS(variant) && variant.isNewSkiPassValid"
								>, {{ variant.skipass}}</span
							>
							<span
								class="d-none d-md-block me-1"
								v-if="isServiceToDisplayDuration(optionName) && isCS(variant)"
								>, {{ variant.skipass }}</span
							>
							<span
								class="d-none d-md-block"
								v-if="isServiceToDisplayDuration(optionName)"
								>{{ content.days }}</span
							>
							{{ ")" }}
						</span>
					</span>
				</div>
			</div>
		</template>
		<template v-if="isDisplayPlaceholders">
			<PlaceholderBox :minHeight="'25px'" />
		</template>
	</div>
</template>

<script>
import { mapState } from "vuex"
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue"
import iconSizes from "@/config/iconSizes"
import packOptionsConfig from "@/config/packOptionsConfig"
import colors from "@/config/colors"
import { isCS } from "@/vue/planning/logic/cs"
import { isServiceToDisplayDuration } from "@/vue/planning/logic/isServiceToDisplayDuration"
import getServiceDuration from "@/vue/planning/logic/getServiceDuration"
import store from "@/vue/planning/store/store"

export default {
	store,
	name: "Inclus",
	props: {
		isDisplayPlaceholders: {
			type: Boolean,
			default: false,
		},
		isPierreVacance: {
			type: Boolean,
			default: false,
		},
		variant: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	components: {
		PlaceholderBox,
	},

	computed: {
		...mapState(["content", "participants"]),
		packCode() {
			if (!this.variant) return ""
			return this.variant["codePackage"]
		},
		iconSize() {
			return iconSizes.l
		},
		iconSize_adult() {
			return iconSizes.l
		},
		iconSize_child() {
			return iconSizes.s
		},
		iconColor() {
			return colors.darkBlue
		},
		currentPackConfig() {
			return packOptionsConfig[this.packCode] || {}
		},
		participantsLength_adults() {
			return this.participants.filter((age) => age >= 18).length
		},
		participantsLength_children() {
			return this.participants.filter((age) => age < 18 && age > 1).length
		},
	},

	methods: {
		isCS,
		isServiceToDisplayDuration,
		getServiceDuration,
	},
}
</script>

<style scoped></style>
